// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"o32bociaZfpNbMnBCg5tJw=="};